<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M18.534 4.248H5.501c-.92 0-1.667.746-1.667 1.667v20.667c0 .92.746 1.666 1.667 1.666h20.666c.92 0 1.667-.746 1.667-1.666V13.548l-2-2v14.7h-20v-20h14.7l-2-2zm3.174.293a1 1 0 011.414 0l4.42 4.42a1 1 0 01-1.415 1.413l-4.42-4.419a1 1 0 010-1.414z" clip-rule="evenodd"/><path d="M18.334 4.248h4.167v2h-4.167v-2z"/><path fill-rule="evenodd" d="M22.334 4.415h-3.833v1.667h3.833V4.415zm-4-.167v2h4.167v-2h-4.167z" clip-rule="evenodd"/><path d="M25.834 9.748h2v4h-2v-4zm-15.667-3.5a1 1 0 011-1h9.167a1 1 0 011 1v3.667a1 1 0 01-1 1h-9.167a1 1 0 01-1-1V6.248zm-.999 13.666a1 1 0 011-1h11.333a1 1 0 011 1v6a1 1 0 01-1 1H10.168a1 1 0 01-1-1v-6z"/></svg>
</template>

<script>
export default {
  name: 'objectsFloppyDiskFilled'
}
</script>
